import React from 'react';
import { Tag, Tooltip } from 'antd';
import { HeartOutlined } from '@ant-design/icons';

/**
 * Petit badge affiché à côté du nom d'une communauté de type "wellbeing"
 * partout où une liste de communautés est rendue.
 */
export const WellbeingBadge: React.FC<{ type?: string }> = ({ type }) => {
  if (type !== 'wellbeing') return null;
  return (
    <Tooltip title="Communauté Bien-être">
      <Tag
        color="#FF9966"
        style={{ marginLeft: 4, fontSize: 10, lineHeight: '16px', padding: '0 6px' }}
      >
        <HeartOutlined /> Bien-être
      </Tag>
    </Tooltip>
  );
};
